import React from "react";
import { Redirect, Route } from "react-router-dom";
import { warn } from "../utils/logger";

// State
import PropTypes from "prop-types";
import { connect } from "react-redux";

// Error Page
import Loader from "../components/Loader";
import Page401 from "../pages/auth/Page401";
import { saveDesiredPage } from "../redux/actions/userActions";

const RestrictedRoute = ({
  isAuthenticated,
  loading,
  user,
  restrictedToLevel,
  userLevel,
  ...rest
}) => {
  // If user does not have minimum permission level once loading finishes, display 401 page
  if (loading) {
    return <Loader />;
  }
  if (!isAuthenticated) {
    warn(`[i] Unauthenticated user visited url[${window.location.pathname}]`);
    saveDesiredPage(); // Store desired page to session storage
    return <Route {...rest} render={(props) => <Redirect to="/auth/sign-in" {...props} />} />;
  }
  if (userLevel < restrictedToLevel) {
    warn(`[i] Unauthenticated user visited url[${window.location.pathname}]`);
    return <Page401 />;
  }

  // User is authenticated, show route
  return <Route {...rest} />;
};

RestrictedRoute.propTypes = {
  loading: PropTypes.bool.isRequired,
  userLevel: PropTypes.number.isRequired,
  restrictedToLevel: PropTypes.number.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  user: state.user.user,
  userLevel: state.user.user.group_id_bint || 0,
  isAuthenticated: state.user.isAuthenticated,
});

export default connect(mapStateToProps)(RestrictedRoute);
